import React from 'react';
import { FormExportador } from './FormExportador';
import { FormObservacao } from './FormObservacao';

export const Produtor: React.FC = () => {
  return (
    <>
      <FormExportador />
      <FormObservacao />
    </>
  );
};
